document.addEventListener('DOMContentLoaded', () => {
  const videoCarousel = new Siema({
    selector: '.ugc-video-carousel',
    duration: 300,
    perPage: { 0:1, 769:4 },
    draggable: true,
    threshold: 20,
    loop: false,
  });
  const imageCarousel = new Siema({
    selector: '.ugc-image-carousel',
    duration: 300,
    perPage: { 0:2, 769:3 },
    draggable: true,
    threshold: 20,
    loop: false,
  });

  // Optional: Pfeile nur mobil anzeigen und mit Siema steuern
  document.querySelectorAll('.ugc-video-carousel .carousel-prev').forEach(el =>
    el.addEventListener('click', () => videoCarousel.prev()));
  document.querySelectorAll('.ugc-video-carousel .carousel-next').forEach(el =>
    el.addEventListener('click', () => videoCarousel.next()));
  document.querySelectorAll('.ugc-image-carousel .carousel-prev').forEach(el =>
    el.addEventListener('click', () => imageCarousel.prev()));
  document.querySelectorAll('.ugc-image-carousel .carousel-next').forEach(el =>
    el.addEventListener('click', () => imageCarousel.next()));

  // Magnific Popup für Bilder
  $('.ugc-image-carousel').magnificPopup({
    delegate: 'a.img-lightbox',
    type: 'image',
    gallery: { enabled: true },
    mainClass: 'mfp-img-mobile',
    closeOnContentClick: true
  });
});
// custom.js
document.addEventListener('DOMContentLoaded', () => {
  const videoSiema = new Siema({
    selector: '.ugc-video-carousel',
    perPage: { 0:1, 769:4 },
    draggable: true,
    threshold: 20,
  });
  const imageSiema = new Siema({
    selector: '.ugc-image-carousel',
    perPage: { 0:2, 769:3 },
    draggable: true,
    threshold: 20,
  });

  $('.ugc-image-carousel').magnificPopup({
    delegate: 'a.img-lightbox',
    type: 'image',
    gallery: { enabled: true },
    mainClass: 'mfp-img-mobile',
    closeOnContentClick: true
  });
});
